let headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export function authHeader() {
  const token = localStorage.getItem('token');
  if (token && token.length) {
    return { 'Authorization' : `Bearer ${token}` };
  }

  return { };
}

export default headers;



// WEBPACK FOOTER //
// ./routes/Headers.js